// extracted by mini-css-extract-plugin
export var background = "ProgramContentCard-module--background--7d5fd";
export var copyLeft = "ProgramContentCard-module--copy-left--4981e";
export var copyRight = "ProgramContentCard-module--copy-right--77ffc";
export var grid = "ProgramContentCard-module--grid--67275";
export var height = "ProgramContentCard-module--height--9fdf4";
export var imageAdjust = "ProgramContentCard-module--image-adjust--73bea";
export var imageGrid = "ProgramContentCard-module--image-grid--73769";
export var imageLeft = "ProgramContentCard-module--image-left--94b17";
export var imageRight = "ProgramContentCard-module--image-right--dec44";
export var mainImageContainer = "ProgramContentCard-module--main-image-container--db969";
export var padAdjust = "ProgramContentCard-module--pad-adjust--e8788";
export var programImage = "ProgramContentCard-module--program-image--a2594";